import actionTypes from '../actions/action-types';

export default (state = 0, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PACKS_GROSS_VALUE_LIST_SUCCESS:
      return action.packsGrossValue;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/reducers/packs-gross-value.js